module.exports = __webpack_public_path__ + "static/img/t1.024396e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/t1.jpg
// module id = sj4e
// module chunks = 11